import { useCallback, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

export const useParams = () => {
  const [params, setParams] = useState([]);

  const [activeParam, setActiveParam] = useState(null);

  const onParamChange = useCallback(
    (paramName, value) => setParams((oldParams) => oldParams
      .map((op) => (op.name === paramName ? { ...op, ...value } : op))),
    [],
  );

  const onMoveUp = useCallback(
    (name) => setParams((oldParams) => {
      const cSort = oldParams.filter((prm) => prm.name === name).reduce((R, prm) => prm.sort, null);
      if (!cSort) return oldParams;
      const nSort = Math.max(
        ...oldParams.filter((prm) => (prm.sort || 0) < cSort).map((p) => p.sort),
      );
      return oldParams.map((p) => {
        if (p.sort === cSort) return { ...p, sort: nSort };
        if (p.sort === nSort) return { ...p, sort: cSort };
        return p;
      }).sort((a, b) => a.sort - b.sort);
    }),
    [],
  );

  const onMoveDown = useCallback(
    (name) => setParams((oldParams) => {
      const cSort = oldParams.filter((prm) => prm.name === name).reduce((R, prm) => prm.sort, null);
      if (!cSort) return oldParams;
      const nSort = Math.min(
        ...oldParams.filter((prm) => (prm.sort || 0) > cSort).map((p) => p.sort),
      );
      return oldParams.map((p) => {
        if (p.sort === cSort) return { ...p, sort: nSort };
        if (p.sort === nSort) return { ...p, sort: cSort };
        return p;
      }).sort((a, b) => a.sort - b.sort);
    }),
    [],
  );

  const paramsHandlers = useMemo(() => ({
    onParamChange,
    setActiveParam,
    onMoveUp,
    onMoveDown,
  }), [onMoveDown, onMoveUp, onParamChange]);

  return {
    params, setParams, activeParam, paramsHandlers,
  };
};

export const paramPropType = PropTypes.shape({
  name: PropTypes.string,
  label: PropTypes.string,
  ctype: PropTypes.string,
  mandatory: PropTypes.bool,
  plural: PropTypes.bool,
  resource: PropTypes.string,
});
